// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__ZTha+","title":"Skill_title__-CYzL","text":"Skill_text__fputz"};